module.exports = __webpack_public_path__ + "img/MCD_Unternehmen_Big_Teaser_01.d3524c39.jpg";